
export const REQUEST_USER_LOGIN = 'REQUEST_USER_LOGIN';
export const USER_LOGIN_RECEIVED = 'USER_LOGIN_RECEIVED';
export const REQUEST_USER_LOGOUT = 'REQUEST_USER_LOGOUT';
export const USER_LOGOUT_RECEIVED = 'USER_LOGOUT_RECEIVED';
